/*@flow*/
import type { Element } from 'react';
import React, { useState } from 'react';
import cx from 'classnames';
import Caret from './Caret';

type PropsT = {
  pathKey: string | number,
  iconClass: string,
  label: React$Node,
  children: React$Node,
};

export default function StructTemplate({
  pathKey,
  iconClass,
  label,
  children,
}: PropsT): Element<'div'> {
  const [isActive, setActive] = useState(true);

  return (
    <div
      id={cx(`section-${pathKey}`)}
      className={cx('drawer-section', { active: isActive })}
      data-testid="Section"
    >
      <div className="drawer-section-header">
        <a
          data-testid="ToggleSectionContent"
          className="d-flex w-100 text-left justify-content-between"
          onClick={() => setActive((v) => !v)}
        >
          <span>
            <i className={cx('fa', iconClass)} /> {label}{' '}
          </span>
          <Caret isActive={isActive} />
        </a>
      </div>
      {isActive && (
        <section
          data-testid="SectionContent"
          className="drawer-section-content"
        >
          {children}
        </section>
      )}
    </div>
  );
}
